import { z } from "zod";

/**
 * A model usable as a training-eval judge (`trainingJob.listAvailableJudgeModels`).
 * Plain Postgres text columns — no enums, dates, or aggregates.
 */
export const judgeModelSummarySchema = z.object({
  id: z.string(),
  canonicalAlias: z.string(),
  name: z.string(),
  huggingFaceId: z.string().nullable(),
  ownerTeamId: z.string(),
});

/**
 * The presigned download for a completed training job's final model artifact
 * (`trainingJob.getFinalModelDownload`). `sizeBytes` is a `bigint` column in
 * `mode: "number"`, so Drizzle returns a JS number (not a string).
 */
export const trainingFinalModelDownloadSchema = z.object({
  checkpointId: z.string(),
  r2Path: z.string(),
  downloadUrl: z.string(),
  fileName: z.string(),
  sizeBytes: z.number().nullable(),
});

/**
 * One step of a training run's metrics (`trainingJob.getMetrics`), read from
 * ClickHouse. `step` is a `UInt32` (safe as a number); `timestamp` is
 * `toString()`'d in SQL, so it is a zone-less `YYYY-MM-DD HH:MM:SS.mmm` STRING,
 * not an ISO/Date. `loss`/`learningRate` are non-null `Float64`; the rest are
 * `Nullable(Float64)`.
 */
export const trainingMetricPointSchema = z.object({
  step: z.number(),
  loss: z.number(),
  learningRate: z.number(),
  gradNorm: z.number().nullable(),
  throughputTokensPerSec: z.number().nullable(),
  memoryUsedGb: z.number().nullable(),
  timestamp: z.string(),
});
